import React from 'react';
import Register from '../features/auth/components/Register';
import { useAuth } from '../contexts/AuthContext';

const RegisterPage: React.FC = () => {
    const { navigateToLogin } = useAuth();
    return <Register onNavigateToLogin={navigateToLogin} />;
};

export default RegisterPage;
